import urls from '../constants/urls.js';
import { fetch } from 'domain-task';
import BaseService from './baseService';

class GigService {   
    static getGig(id) {
        return BaseService.getAndReturn(`/Gigs/${id}`, BaseService.returnAssignedObject, 'Unable to fetch gig', true);
    }

    static browseGigs (keyword, genres, distance, distanceUnit, latitude, longitude, startDate, endDate, sort, page) {    
        let url = '';
        if(keyword) {
            url = `/Gigs?page=${page}&keyword=${keyword}`;
        }
        else {
            let genreQuery = '';
            genres.forEach(genre => {
                genreQuery += `&genres=${encodeURIComponent(genre)}`;
            }); 
            url = `/Gigs?page=${page}${genreQuery}&distance=${distance || ''}&distanceUnit=${distanceUnit || ''}&latitude=${latitude || ''}&longitude=${longitude || ''}&startDate=${startDate || ''}&endDate=${endDate || ''}&sort=${sort || ''}`;
        }        
        return BaseService.getAndReturn(url, BaseService.returnAssignedObject, 'Unable to complete search', true, 'Unable to complete search');
    } 
}
export default GigService;